import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    attributeName: 'permission',
    isDragable: false,
    canOpen: false,
    canEdit: false,
    canCreate: false,
    canRemove: false,
    isSelectable: true,
    isMultiSelectable: true,
    emptyMessage: "You don't have contents, visit the content section to create one.",
    getURL: 'permissions',
    fields: [
      {
        attributeName: 'description',
        label: 'Description',
        type: FormInputTypes.TEXT_INPUT.TEXT,
        default: '',
        canOrder: false,
        canEdit: false,
        canCreate: false,
        canOpen: true,
        canFilter:true,
        helpText: 'Name of the permission.',
      },
    ],
}